import React from 'react'
import Box from '@bit/atd.web.box'
import Icons from '@bit/atd.web.icons'
import { ReactElement } from 'react'

const QueryError = (): ReactElement => (
  <Box>
    <div>
      <h1>
        Network error! <Icons glyph="alert" />{' '}
      </h1>
      <p>
        We're sorry, there was a problem retrieving information from the server,
        please refresh the page or try again later.{' '}
      </p>
    </div>
  </Box>
)

export default QueryError
